




























































































































import Vue, { PropOptions } from 'vue';
import { IFrame as ifr, CFrame, IFrameEdit } from './GadgetFrame.vue';
export type IFrame = ifr;
export { CFrame };
import ClickOutside from 'vue-click-outside';

// export interface IFrame {
//   error: boolean;
//   show: boolean;
//   disabled: boolean;
//   detail: boolean;
//   cover: boolean;
//   edit: boolean;
//   options: boolean;
//   sample: boolean;
// }

// export  class CFrame implements IFrame {
//   public error = false;
//   public show = true;
//   public disabled = false;
//   public detail = false;
//   public cover = false;
//   public edit = false;
//   public options = false;
//   public sample = false;
// }

// export interface IFrameEdit {
//   title: string;
//   comment: string;
// }
export default Vue.extend({
  name: 'GadgetFrame',
  props: {
    title: String,
    csvtitle: String,
    comment: String,
    frameData: Object as PropOptions<IFrame>,
    options: Object,
    optionItems: Array,
    helpmodal: String,
  },
  directives: {
    ClickOutside,
  },
  data() {
    return {
      titleEdit: '',
      type: '',
      materials: {},
      memoBack: false,
      memoScroll: false,
      memoClick: false,
      commentEditFlag: false,
      commentEdit: '',
      optionsModal: false,
      csvframe: false,
    };
  },
  computed: {
    EDIT() {
      // return this.edit ? '' : 'no_edit';
      return false;
    },
    TITLE_CLASS() {
      // 幅調整用にアイコンをカウント
      let count = 0;
      if (!this.frameData.noicons) {
        if (this.frameData.edit) {
          count++; // pen
        } else {
          if (this.frameData.sample) {
            count += this.frameData.cover ? 1 : 2; // question [+ trash]
          } else {
            count += 3; // question + trash + pen;
          }
        }
        count += this.frameData.options ? 1 : 0;
        count += this.frameData.detail && this.optionItems.length > 0 ? 1 : 0;
      }

      return ['title', `i${count}`];
    },
  },
  mounted() {
    this.$data.titleEdit = this.$props.title;
    this.$data.commentEdit = this.$props.comment.replace(/<br>/gi, '\n');
  },
  methods: {
    returnSetting(key: string): any {
      return (this as any).frameData[key] ? (this as any).frameData[key] : false;
    },
    onClickDetail() {
      if (!this.frameData.cover) {
        this.$emit('detail');
      }
    },
    onClickTrash() {
      if (!this.frameData.cover) {
        this.$emit('trash');
      } else {
        this.$emit('delete');
      }
    },
    onClickAddEvent() {
      this.$emit('add');
    },
    onClickQuestionEdit() {
      this.commentEditFlag = !this.commentEditFlag;
    },
    onClickGadgetEdit() {
      this.$emit('edit');
    },
    onMemoback(flag: boolean) {
      const result = flag;
      /*
      if (this.edit) {
        result = false;
      }
      */
      if (!this.memoScroll || !this.memoClick) {
        this.memoBack = result;
        const memodom = this.$refs.memodom as Element;
        if (memodom.scrollHeight > memodom.clientHeight) {
          // スクロールバーが出たら「メモを見る」表示
          this.memoScroll = true;
        }
      }
    },
    onClickOptions() {
      this.optionsModal = !this.optionsModal;
    },
    onOutsideClick() {
      this.optionsModal = false;
    },
  },
  watch: {
    type() {
      // console.log('type chnage');
    },
    titleEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    commentEdit() {
      this.$emit('frameDataEdit', {title: this.titleEdit, comment: this.commentEdit} as IFrameEdit);
    },
    options() {
      this.optionsModal = false;
    },
    // item() {
    //   this.type = this.item.gadgetData.type;
    //   this.materials = this.item.gadgetData.materials;
    // },
  },
});

